import { make } from 'vuex-pathify'
import axios from 'axios'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import store from '@/store'

const state = {
  billings: {
    data: [],
    count: 0,
    limit: 25,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['updatedAt'],
    sortDesc: [true],
  },

  loading: false,
  actionLoading: {},
}

const mutations = make.mutations(state)

function setActionLoading (state, key, value) {
  state.actionLoading = {
    ...state.actionLoading,
    [key]: value,
  }
}

const actions = {
  get: async ({ state }, filter = state.filter) => {
    state.loading = true

    return axios
      .get(`${process.env.VUE_APP_API_URL}/payment-provider-billings?${getQueryFromFilter(filter)}`)
      .then((res) => {
        state.billings = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  reprocess: async ({ state, dispatch }, item) => {
    const key = `reprocess-${item.id}`
    setActionLoading(state, key, true)

    return axios
      .post(`${process.env.VUE_APP_API_URL}/payment-provider-billings/${item.id}/reprocess`, {
        companyId: store.get('authStore@currentCompany')?.id,
      })
      .then((res) => {
        showSuccess('Cobrança enfileirada para reprocessamento')
        return res.data
      })
      .catch(showError)
      .finally(() => setActionLoading(state, key, false))
  },

  edit: async ({ state, dispatch }, { id, payment }) => {
    const key = `edit-${id}`
    setActionLoading(state, key, true)
    state.loading = true

    return axios
      .post(`${process.env.VUE_APP_API_URL}/payment-provider-billings/${id}/edit`, {
        companyId: store.get('authStore@currentCompany')?.id,
        payment,
      })
      .then((res) => {
        showSuccess('Cobrança editada com sucesso')
        return dispatch('get').then(() => res.data)
      })
      .catch(showError)
      .finally(() => {
        setActionLoading(state, key, false)
        state.loading = false
      })
  },

  cancel: async ({ state, dispatch }, item) => {
    const key = `cancel-${item.id}`
    setActionLoading(state, key, true)
    state.loading = true

    return axios
      .post(`${process.env.VUE_APP_API_URL}/payment-provider-billings/${item.id}/cancel`, {
        companyId: store.get('authStore@currentCompany')?.id,
      })
      .then((res) => {
        showSuccess('Cobrança cancelada com sucesso')
        return dispatch('get').then(() => res.data)
      })
      .catch(showError)
      .finally(() => {
        setActionLoading(state, key, false)
        state.loading = false
      })
  },

  sendEmail: async ({ state, dispatch }, item) => {
    const key = `email-${item.id}`
    setActionLoading(state, key, true)

    return axios
      .post(`${process.env.VUE_APP_API_URL}/payment-provider-billings/${item.id}/email`, {
        companyId: store.get('authStore@currentCompany')?.id,
      })
      .then((res) => {
        showSuccess('Envio de e-mail enfileirado com sucesso')
        dispatch('get')
        return res.data
      })
      .catch(showError)
      .finally(() => setActionLoading(state, key, false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
